import React from 'react';
import times from 'lodash/times';

const LoadingPlaceholder = ({ 
  rows = 1, 
  type = 'line', 
  className = '' 
}) => {
  const renderLoadingItem = (index) => {
    switch (type) {
      case 'line':
        return <div key={index} className="loading-line" />;
      case 'line-small':
        return <div key={index} className="loading-line loading-line-small" />;
      case 'line-large':
        return <div key={index} className="loading-line loading-line-large" />;
      case 'card':
        return <div key={index} className="loading-card" />;
      case 'card-large':
        return <div key={index} className="loading-card-large" />;
      case 'account-section':
        return <div key={index} className="loading-account-section" />;
      case 'avatar':
        return <div key={index} className="loading-avatar" />;
      case 'text':
        return <div key={index} className="loading-text" />;
      case 'text-short':
        return <div key={index} className="loading-text loading-text-short" />;
      case 'text-medium':
        return <div key={index} className="loading-text loading-text-medium" />;
      default:
        return <div key={index} className="loading-line" />;
    }
  };

  return (
    <div className={`loading-container ${className}`}>
      {times(rows).map((_, index) => renderLoadingItem(index))}
    </div>
  );
};

export default LoadingPlaceholder;
